import { IEmployee } from '@cbgms/api'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'

export const useEmployeeLoggingData = () => {
  return useSelector<IRootReducerState, IEmployee>(state => state.auth.employee)
}
